import { axiosCreate } from "@config/index"
import { verifyBodyResponse } from "@thelpers/verifyBodyResponse"

export const getLogsData = async ({ url, token, format, company_id, limit, skip, otherParams }) => {

    const params = {
        ...otherParams,
        company_id,
        limit,
        skip,
        format,
    }
    try {
        const res = await axiosCreate.get(url, {
            params,
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        return verifyBodyResponse(res, true)
    } catch (error) {
        console.error(error)
        return verifyBodyResponse(error, false)
    }

}